






























import { Vue, Prop, Component } from 'vue-property-decorator';
import { PhoneCountryCode } from '@/models/PhoneCountryCode';
@Component
export default class PhoneCountryCodeInput extends Vue {
    @Prop() label!: string;
    @Prop() countryCodes!: PhoneCountryCode[];
    @Prop() value!: string;
    phoneNumber: string = '';
    selectedItem!: PhoneCountryCode;
    expanded: boolean = false;

    get selectedFlagPath(): string {
        if (this.countryCodes.length > 0) {
            return '/ui/assets/' + this.selectedItem.cssClass + '.svg';
        }
        return '';
    }

    constructor() {
        super();
        this.selectedItem = this.countryCodes.find((code: PhoneCountryCode) => code.selected) || this.countryCodes[0];
    }

    handleInput() {
        this.phoneNumber = this.phoneNumber.replace(/\D/g, '');
        this.phoneNumber = this.phoneNumber.replace(/^0+/, '');
        this.$emit('input', this.selectedItem.code + this.phoneNumber);
    }

    existsInArray(arr: string[], val: string): boolean {
        if (typeof arr === 'undefined') {
            return false;
        }
        return arr.some(arrVal => {
            return val === arrVal;
        });
    }

    unexpand(e: FocusEvent) {
        if (e.relatedTarget == null || !this.$el.contains(e.relatedTarget as Node)) {
            this.expanded = false;
        }
    }

    expand() {
        if (this.countryCodes.length > 0) {
            this.expanded = !this.expanded;
        }
    }

    selectOption(payload: PhoneCountryCode) {
        this.selectedItem = payload;
        this.$emit('change', this.selectedItem);
        this.expanded = false;
        this.handleInput();
    }
}
